import { API_endpoints } from "../config";

export const getSlotBookingDateCounter = async (startDate:Date,endDate:Date): Promise<any> => {
    try {
        const body =  { 
            start_date: startDate.toISOString().split('T')[0],
            end_date: endDate.toISOString().split('T')[0]
         } ;
        const response = await fetch(API_endpoints.getSlotBookingDateCounter, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von Buchungszähler Daten.");
        }
    

        return await response.json();

        
    } catch (error) {
        console.error("Fehler beim Laden von Buchungszähler Daten:", error);
    }
};
